import { KeyboardEvent, ReactNode } from 'react';
import classNames from 'classnames';
import { Skeleton } from 'antd';
import { ESTIMATE_TAG } from '../labels';
import styles from '../styles.module.scss';

export interface StatTileProps {
  title: ReactNode;
  /** Số lớn (màu heading, như trang Điểm Sao — Tổng quan). */
  value: ReactNode;
  /** Dòng phụ (vd. "đến 27/09", `kc.sameDay.label`). */
  sub?: ReactNode;
  /** Đang tải lần đầu: hiện Skeleton (mục 8.7). */
  loading?: boolean;
  /** Số là ước tính → thẻ "ước tính" cạnh tiêu đề. */
  estimated?: boolean;
  /** Góc phải tiêu đề (vd. CountPill). */
  extra?: ReactNode;
  /** Bấm cả ô (vd. mở tab Cần xử lý). */
  onClick?: () => void;
  ariaLabel?: string;
}

/** Ô số của trang Studio (mục 8.7.4, 8.7.7). Lưới 4 ô: bọc bằng `<div className={styles.statGrid}>`. */
const StatTile = ({
  title,
  value,
  sub,
  loading,
  estimated,
  extra,
  onClick,
  ariaLabel,
}: StatTileProps) => {
  const onKeyDown = (e: KeyboardEvent<HTMLDivElement>) => {
    if (!onClick) return;
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onClick();
    }
  };

  return (
    <div
      className={classNames(styles.statTile, { [styles.statTileClickable]: !!onClick })}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      aria-label={ariaLabel}
      onClick={onClick}
      onKeyDown={onClick ? onKeyDown : undefined}
    >
      <div className={styles.statTitle}>
        <span>
          {title}
          {estimated && (
            <>
              {' '}
              <span className={styles.estimateTag}>{ESTIMATE_TAG}</span>
            </>
          )}
        </span>
        {extra}
      </div>
      {loading ? (
        <Skeleton active title={false} paragraph={{ rows: 2 }} />
      ) : (
        <>
          <div className={styles.statValue}>{value}</div>
          {sub && <div className={styles.statSub}>{sub}</div>}
        </>
      )}
    </div>
  );
};

export default StatTile;
